var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VueCarousel-slide",class:{
    'VueCarousel-slide-active': _vm.isActive,
    'VueCarousel-slide-center': _vm.isCenter
  },attrs:{"tabindex":"-1"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }